<app-display-card>
  <div class="ins-findings">
    @for (
      InsuranceCertificateFindingResult of InsuranceCertificateFindingResults
        | keyvalue;
      track InsuranceCertificateFindingResult
    ) {
      <div class="inner-panel rounded ins-findings__panel">
        <div class="ins-findings__title">
          <span class="ins-findings__title-eyebrow">Certificate</span>
          <span class="ins-findings__title-value">
            {{
              getInsurancePoliciesOnCertificate(
                InsuranceCertificatesMappedById.get(
                  castStringToNumber(InsuranceCertificateFindingResult.key)
                )!
              ).join(', ')
            }}
          </span>
        </div>

        <div class="ins-findings__head">
          <label>Field</label>
          <label>Finding</label>
          <label>Setting</label>
          <label>Result</label>
        </div>

        @for (
          result of InsuranceCertificateFindingResult.value | keyvalue;
          track result
        ) {
          <div class="ins-findings__row">
            <label>{{ InsuranceResultToLabelMap[result.key].label }}</label>
            <label>
              {{
                InsuranceCertificatesMappedById.get(
                  castStringToNumber(InsuranceCertificateFindingResult.key)
                )![castStringAsKeyofInsuranceCertificate(result.key)]
                  ? 'Yes'
                  : 'No'
              }}
            </label>
            <label>Required</label>
            <label class="chip-host" appStatusStyleChanges>
              {{ result.value }}
            </label>
          </div>
        }
      </div>
    }
  </div>
</app-display-card>
